import { FC } from 'react'
import Width from '@/assets/img/icons/width.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={Width}
      alt='IconLightTower'
      width={width}
      height={height}
    />
  )
}

export default Icon
